<template>
  <div :style="{ minHeight: $store.store.state.windowheight + 'px' }">
    <div class="wrapper">
      <img
        v-if="bannerimg"
        :src="$store.store.state.windonsrc + bannerimg"
        style="width: 100%; height: auto"
      />
    </div>
    <div
      class="contentwidth notice_content"
      style="display: flex; justify-content: space-between"
    >
      <div
        class="notice_img"
        @click="
          $store.actions.goInfo(
            newlist1[0].id,
            '/front/handleGuide/info/',
            '工作动态',
            1
          )
        "
      >
        <img
          :src="$store.store.state.windonsrc + newlist1[0].imgBase64"
          style="width: 100%; height: 100%"
          v-if="newlist1[0].imgBase64"
        />
        <div class="notice_img_black">
          <el-tooltip
            effect="dark"
            :content="newlist1[0].title"
            placement="top-start"
            v-if="newlist1[0].title.length > 27"
          >
            <span> {{ newlist1[0].title }}</span>
          </el-tooltip>
          <span v-else> {{ newlist1[0].title }}</span>
        </div>
      </div>
      <div class="classmenu_party">
        <div class="flex title">
          <div class="flex title_left">
            <div class="title_border"></div>
            <div class="title_text">工作动态</div>
          </div>
          <el-link :underline="false" @click="goContent('7_1', 0)"
            >更多》</el-link
          >
        </div>
        <ul class="notice_content_ul">
          <li
            v-for="(item, index) in newlist1.slice(1, 10)"
            :key="index"
            @click="
              $store.actions.goInfo(
                item.id,
                '/front/handleGuide/info/',
                '工作动态',
                1
              )
            "
          >
            <div class="notice_li_tips"></div>
            <div class="notice_content_in">
              <el-tooltip
                effect="dark"
                :content="item.title"
                placement="top"
                v-if="item.title.length > 38"
              >
                <p>{{ item.title }}</p>
              </el-tooltip>
              <p v-else>{{ item.title }}</p>
              <p>{{ item.createTime.slice(0, 10) }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="contentwidth centerbanner">
      <img
        v-if="bannerimg2"
        :src="$store.store.state.windonsrc + bannerimg2"
        style="width: 100%; height: 89px"
      />
      <img v-else src="../../../static/images/common/public2.png" />
    </div>
    <div class="contentwidth">
      <div class="flex title">
        <div class="flex title_left">
          <div class="title_border"></div>
          <div class="title_text">科普宣传</div>
        </div>
        <el-link :underline="false" @click="goContent('7_2', 1)"
          >更多》</el-link
        >
      </div>
      <ul class="public3">
        <li
          v-for="(item, index) in newlist2"
          :key="index"
          @click="
            $store.actions.goInfo(
              item.id,
              '/front/handleGuide/info/',
              '科普宣传',
              1
            )
          "
        >
          <div>
            <el-tooltip
              effect="dark"
              :content="item.title"
              placement="top"
              v-if="item.title.length > 27"
            >
              <p>{{ item.title }}</p>
            </el-tooltip>
            <p v-else>{{ item.title }}</p>
            <p class="puclic3_data">{{ item.createTime.slice(0, 10) }}</p>
          </div>
          <div>
            <img
              v-if="item.imgBase64"
              :src="$store.store.state.windonsrc + item.imgBase64"
            />
          </div>
        </li>
      </ul>
    </div>
    <div class="contentwidth" style="margin-top: 60px">
      <div class="flex title">
        <div class="flex title_left">
          <div class="title_border"></div>
          <div class="title_text">公益活动</div>
        </div>
        <el-link :underline="false" @click="goContent('7_3', 2)"
          >更多》</el-link
        >
      </div>
      <ul class="public4">
        <li
          v-for="(item, index) in newlist3"
          :key="index"
          @click="
            $store.actions.goInfo(
              item.id,
              '/front/handleGuide/info/',
              '公益活动',
              1
            )
          "
        >
          <div
            class="public4_img"
            :class="index % 2 == 0 ? 'public4_left' : 'public4_right'"
          >
            <img
              v-if="item.imgBase64"
              :src="$store.store.state.windonsrc + item.imgBase64"
              style="width: 100%; height: 100%"
            />
          </div>
          <div
            :class="index % 2 == 0 ? 'public4_right' : 'public4_left'"
            class="public4_content"
          >
            <div class="public_content_border"></div>
            <div>
              <p>
                <span>0{{ index + 1 }}</span>

                <spap>{{ item.title }}</spap>
              </p>
              <p>
                {{ item.mainContent }}
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { handleGuide, bannerQuery } from "@/request/api";
export default {
  data() {
    return {
      newlist1: [],
      newlist2: [],
      newlist3: [],
      bannerimg: "",
      bannerimg2: "",
    };
  },
  created() {
    this.getnews();
    this.getbanner();
  },
  methods: {
    getbanner() {
      let data = {
        belongSystemId: 1,
        blongToMenu: 7,
        pageSize: 1,
        pageNumber: 1,
      };
      bannerQuery(data).then((res) => {
        if (res.data.code == 200) {
          this.bannerimg = res.data.data.list[0].imgBase64;
        }
      });
      let data2 = {
        belongSystemId: 1,
        blongToMenu: "7_2",
        pageSize: 1,
        pageNumber: 1,
      };
      bannerQuery(data2).then((res) => {
        if (res.data.code == 200) {
          this.bannerimg2 = res.data.data.list[0].imgBase64;
        }
      });
    },
    getnews() {
      let data = {
        blongToMenu: "7_1",
        pageSize: 10,
        pageNumber: 1,
        belongSystemId: "1",
      };
      handleGuide(data).then((res) => {
        this.newlist1 = res.data.data.list.slice(0, 9);
      });
      let data2 = {
        blongToMenu: "7_2",
        pageSize: 10,
        pageNumber: 1,
        belongSystemId: "1",
      };
      handleGuide(data2).then((res) => {
        this.newlist2 = res.data.data.list.slice(0, 4);
      });
      let data3 = {
        blongToMenu: "7_3",
        pageSize: 10,
        pageNumber: 1,
        belongSystemId: "1",
      };
      handleGuide(data3).then((res) => {
        this.newlist3 = res.data.data.list.slice(0, 4);
      });
    },
    goContent(id, index) {
      this.$router.push({
        path: "/publicwelfare",
        query: {
          id: id,
          index: index,
        },
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  margin-bottom: 60px;
}
.notice_content {
  margin-bottom: 30px;
}
.notice_img {
  width: 460px;
  height: 446px;
  background: url("../../../static/images/common/publictitle.png") no-repeat;
  background-size: cover;
  position: relative;
  cursor: pointer;
}
.notice_img_black {
  width: 100%;
  height: 65px;
  background: url("../../../static/images/common/bg.png");
  padding: 0 10px;
  text-align: center;
  line-height: 65px;
  color: #fff;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: absolute;
  left: 0;
  bottom: 0;
}
.classmenu_party {
  width: 703px;
  padding-top: 7px;
}
.notice_content_ul {
  width: 100%;
  margin-top: 40px;
}
.notice_content_ul li {
  display: flex;
  align-items: center;
  height: 40px;
}
.notice_content_in {
  width: 670px;
  height: 40px;
  border-bottom: 1px dashed #e0e0e0;
  display: flex;
  justify-content: space-between;
}
.notice_content_ul li:last-child .notice_content_in {
  border-bottom: none;
}
.notice_content_in p:first-child {
  width: 550px;
  height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notice_content_in p {
  font-size: 14px;
  color: #4d4d4d;
  line-height: 40px;
  cursor: pointer;
}
.notice_li_tips {
  width: 6px;
  height: 6px;
  background: #018277;
  border-radius: 100px;
  margin: 0 20px 0 14px;
}
.centerbanner {
  margin: 64px auto;
}
.title {
  margin-bottom: 36px;
}
.public3 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.public3 li {
  width: 548px;
  height: 146px;
  background: #f5f5f5;
  list-style-type: none;
  margin-bottom: 32px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4d4d4d;
  box-sizing: border-box;
  box-shadow: 0px 2px 18px 0px rgba(126, 126, 126, 0.2);
  cursor: pointer;
  display: flex;
}
.public3 li div:first-child {
  width: 310px;
  padding: 40px 10px 19px 88px;
}
.public3 li div:last-child {
  width: 243px;
  /* background: #ddd; */
  height: 146px;
}
.public3 li div:last-child img {
  width: 243px;

  height: 146px;
}
.public3 li:first-child {
  background: url("../../../static/images/common/pucblic3-1.png");
}
.public3 li:nth-child(2) {
  background: url("../../../static/images/common/pucblic3-2.png");
}
.public3 li:nth-child(3) {
  background: url("../../../static/images/common/pucblic3-3.png");
}
.public3 li:nth-child(4) {
  background: url("../../../static/images/common/pucblic3-4.png");
}
.public3 li p:first-child {
  width: 100%;
  height: 42px;
  display: block;
  line-clamp: 2; /*多行文本 溢出部分...*/
  box-orient: vertical; /*从上向下垂直排列*/
  overflow: hidden;
  text-overflow: ellipsis; /*设置超出内容显示...*/
}
.puclic3_data {
  margin-top: 20px;
}
.public4 li {
  /* display: flex; */
  height: 172px;
  box-shadow: 0px 2px 18px 0px rgba(126, 126, 126, 0.2);
  margin-bottom: 28px;
  list-style-type: none;
}
.public4 li > div {
  width: 50%;
  height: 172px;
}

.public4_img {
  width: 100%;
  /* background: #ddd; */
}
.public4 li:nth-child(1) .public4_img {
  background: url("../../../static/images/common/meet1.png");
}
.public4 li:nth-child(2) .public4_img {
  background: url("../../../static/images/common/meet2.png");
}
.public4 li:nth-child(3) .public4_img {
  background: url("../../../static/images/common/meet3.png");
}
.public4 li:nth-child(4) .public4_img {
  background: url("../../../static/images/common/meet4.png");
}
.public4_right {
  float: right;
}
.public4_left {
  float: left;
}
.public4_content {
  padding: 30px 40px;
  display: flex;
  cursor: pointer;
}
.public_content_border {
  width: 25px;
  height: 4px;
  background: #018277;
  margin-right: 15px;
  margin-top: 15px;
}
.public4_content p:first-child {
  width: 460px;
  border-bottom: solid 1px #e6e6e6;
  padding-bottom: 20px;
  margin-bottom: 15px;
  font-size: 16px;
  color: #4d4d4d;
  margin-top: -15px;
  line-clamp: 2; /*多行文本 溢出部分...*/
  box-orient: vertical; /*从上向下垂直排列*/
  overflow: hidden;
  text-overflow: ellipsis; /*设置超出内容显示...*/
}
.public4_content p:first-child span {
  font-size: 36px;
  color: #616161;
  margin-right: 13px;
}
.public4_content p:last-child {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: #999999;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/welfare/index.vue